import { render, staticRenderFns } from "./xunchajihua.vue?vue&type=template&id=39c641e7&scoped=true&"
import script from "./xunchajihua.vue?vue&type=script&lang=js&"
export * from "./xunchajihua.vue?vue&type=script&lang=js&"
import style0 from "./xunchajihua.vue?vue&type=style&index=0&id=39c641e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c641e7",
  null
  
)

export default component.exports